export enum IntegrationType {
  Datadog = 'datadog',
  DatadogEU = 'datadog_eu',
  Pagerduty = 'pagerduty',
  Newrelic = 'newrelic',
  Grafana = 'grafana',
  Appdynamics = 'appdynamics',
  Prometheus = 'prometheus',
  Dynatrace = 'dynatrace',
  K6 = 'k6',
  Custom = 'custom',
  LoadGeneratorCustom = 'load_generator_custom'
}
